import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ILoginScreen = 'Login' | 'MFAScreen' | 'MFACodeScreen' | 'AccessDeniedScreen';

@Injectable({
    providedIn: 'root',
})
export class SharedService {
    private screenSource = new BehaviorSubject<ILoginScreen>('Login');
    currentScreen = this.screenSource.asObservable();

    changeScreen(screen: ILoginScreen) {
        this.screenSource.next(screen);
    }
}